import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { AuthenticationReferenceType, AuthenticationType, shellStringResources, Credential, IViolation } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: 'AzureDataLakeAnalytics',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataLakeAnalytics_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureDataLakeAnalytics_DisplayText)
    ]
})
export class AzureDataLakeAnalyticsLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountURI
    })
    public accountName?: string;

    @Metamodel.attribute({
        display: stringResources.SubscriptionId
    })
    public subscriptionId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ResourceGroupName
    })
    public resourceGroupName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant?: string;

    @Metamodel.attribute({
        display: stringResources.Authentication_Reference_Method_Label
    })
    public authenticationReferenceType: AuthenticationReferenceType = AuthenticationReferenceType.Inline;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureDataLakeAnalyticsLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedService: AzureDataLakeAnalyticsLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (GlobalVariables.enableUamiAuthForScopeActivity && linkedService
            && (linkedService.authenticationType === AuthenticationType.UserAssignedManagedIdentity
                || (linkedService.authenticationType === AuthenticationType.ManagedServiceIdentity && linkedService.authenticationReferenceType === AuthenticationReferenceType.Credential))
            && !referencedCredential) {
            return [{
                context: linkedService,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
